<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.4601953125,0C5.420195312500001,0,2.9501953125,2.39,2.9501953125,5.33C2.9501953125,8.28,8.4601953125,16,8.4601953125,16C8.4601953125,16,13.9701953125,8.28,13.9701953125,5.33C13.9601953125,2.39,11.5001953125,0,8.4601953125,0C8.4601953125,0,8.4601953125,0,8.4601953125,0ZM8.4601953125,8C7.0801953125,8,5.9601953125,6.88,5.9601953125,5.5C5.9601953125,4.12,7.0801953125,3,8.4601953125,3C9.8401953125,3,10.9601953125,4.12,10.9601953125,5.5C10.9601953125,6.88,9.8401953125,8,8.4601953125,8C8.4601953125,8,8.4601953125,8,8.4601953125,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'MapMarker',
} as DefineComponent
</script>
